/*
Copyright 2026 Peaceful Vanilla Chat

SPDX-License-Identifier: AGPL-3.0-only OR GPL-3.0-only OR LicenseRef-Element-Commercial
Please see LICENSE files in the repository root for full details.
*/

// Registration tokens are bearer credentials. Keep the current token only in
// this page's JavaScript memory so it cannot enter URL/history/proxy logs or
// persistent browser storage. A full reload deliberately requires a new check.
let registrationToken = "";

export function setRegistrationTokenInMemory(token: string): void {
    registrationToken = token.trim();
}

export function peekRegistrationTokenInMemory(): string {
    return registrationToken;
}

export function clearRegistrationTokenInMemory(): void {
    registrationToken = "";
}

/**
 * Remove obsolete PVChat registration bearer parameters before normal routing
 * or deep-link persistence can inspect them. Tokens are intentionally ignored:
 * the only supported handoff is the in-memory value returned by Turnstile.
 */
export function scrubRegistrationTokenFromUrl(): void {
    const currentUrl = new URL(window.location.href);
    currentUrl.searchParams.delete("token");
    currentUrl.searchParams.delete("registration_token");

    const rawHash = currentUrl.hash.startsWith("#") ? currentUrl.hash.slice(1) : currentUrl.hash;
    const hashUrl = new URL(rawHash || "/", currentUrl.origin);
    hashUrl.searchParams.delete("token");
    hashUrl.searchParams.delete("registration_token");
    currentUrl.hash = rawHash ? `#${hashUrl.pathname}${hashUrl.search}${hashUrl.hash}` : "";

    if (currentUrl.toString() !== window.location.href) {
        window.history.replaceState(window.history.state, "", currentUrl.toString());
    }
}
